import { createTheme } from "@mui/material/styles";
import { customPalette, muiPaletteOptions } from "./palette";
import { spacing } from "./styles";

export const theme = createTheme({
  palette: muiPaletteOptions,
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily:
      '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    body1: {
      fontSize: "18px",
      lineHeight: "36px",
      fontWeight: 400,
      color: customPalette.text.primary,
    },
    h2: {
      fontSize: "32px",
      fontWeight: 800,
      lineHeight: "32px",
      marginTop: "16px",
      marginBottom: "16px",
    },
    h4: {
      fontSize: "22px",
      fontWeight: 700,
    },
    pageTitle: {
      fontSize: "32px",
      fontWeight: 800,
      lineHeight: "44px",
      color: customPalette.text.primary,
      letterSpacing: "0.1px",
      textTransform: "capitalize",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: "large",
        variant: "contained",
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          fontWeight: 800,
          letterSpacing: "1px",
          borderRadius: "4px",
          lineHeight: "1",
          variants: [
            {
              props: { variant: "contained", disabled: false },
              style: {
                backgroundColor: customPalette.purple.strong,
                borderBottom: `2px solid ${customPalette.purple.strong}`,
              },
            },
            {
              props: {
                variant: "contained",
                color: "error",
                disabled: false,
              },
              style: {
                backgroundColor: customPalette.status.warning,
                borderBottom: `2px solid ${customPalette.status.warning}`,
              },
            },
            {
              props: { variant: "outlined", disabled: false },
              style: {
                border: `2px solid ${customPalette.purple.strong}`,
                boxShadow: `0px 2px 0px 0px ${customPalette.purple.stronger}`,
              },
            },
            {
              props: {
                variant: "outlined",
                color: "error",
                disabled: false,
              },
              style: {
                border: `2px solid ${customPalette.status.warning}`,
                boxShadow: `0px 2px 0px 0px ${customPalette.status.warning}`,
                color: customPalette.status.warning,
              },
            },
            {
              props: { size: "small" },
              style: {
                fontSize: "16px",
                paddingTop: spacing.padding.xs,
                paddingBottom: spacing.padding.xs,
                paddingLeft: spacing.padding.sm,
                paddingRight: spacing.padding.sm,
                borderRadius: spacing.radius.xs,
              },
            },
            {
              props: { size: "medium" },
              style: {
                fontSize: "16px",
                padding: "20px 32px",
                borderRadius: spacing.radius.xs,
              },
            },
            {
              props: { size: "large" },
              style: {
                fontSize: "16px",
                padding: "24px 48px",
                borderRadius: spacing.radius.xs,
              },
            },
          ],
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: customPalette.gray["0"],
          variants: [
            {
              props: {
                variant: "filled",
              },
              style: {
                backgroundColor: customPalette.purple.subtle,
              },
            },
          ],
          border: `2px solid ${customPalette.purple.strong}`,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: spacing.radius.md,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "24px",
          fontWeight: 700,
          color: customPalette.purple.strong,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            backgroundColor: customPalette.purple.strong,
            color: customPalette.text.inverted,
            fontWeight: 700,
          },
          "& .MuiTableCell-root:first-of-type": {
            borderTopLeftRadius: spacing.radius.xxs,
          },
          "& .MuiTableCell-root:last-of-type": {
            borderTopRightRadius: spacing.radius.xxs,
          },
        },
      },
    },
  },
});
